"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _memoizeOne = _interopRequireDefault(require("memoize-one"));

var _luxon = require("luxon");

var _chartUtils = require("../../chartUtils");

var _readingsToCoordinates = require("../../transformers/readingsToCoordinates");

var _RecentPerformanceCrosshair = require("../RecentPerformanceCrosshair");

require("react-vis/dist/style.css");

var _FifteenMinuteChart = _interopRequireDefault(require("./FifteenMinuteChart"));

var _useSitePower = require("../../hooks/useSitePower");

var _useMinutePerformance = require("../../hooks/useMinutePerformance");

var _useMinuteBattery = require("../../hooks/useMinuteBattery");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

// Battery
var organizeBatteryReadings = (0, _memoizeOne["default"])(function (readingsAcrossBatteries) {
  return (0, _chartUtils.organizeBatteryReadingsByNumber)(readingsAcrossBatteries);
});
var transformToBatteryAveragePercentageCoordinates = (0, _memoizeOne["default"])(function (readings, timeZone) {
  return readings.filter((0, _chartUtils.isValidReading)('averageBatteryPercentageState')).map((0, _readingsToCoordinates.readingsToCoordinates)(timeZone, 'averageBatteryPercentageState'));
}); // Energy and Power

var transformToConsumptionCoordinates = (0, _memoizeOne["default"])(function (productionReadings, timeZone) {
  return productionReadings.filter((0, _chartUtils.isValidReading)('consumption')).map((0, _readingsToCoordinates.readingsToCoordinates)(timeZone, 'consumption'));
});
var transformToExportCoordinates = (0, _memoizeOne["default"])(function (productionReadings, timeZone) {
  return productionReadings.filter((0, _chartUtils.isValidReading)('exportReading')).map((0, _readingsToCoordinates.readingsToCoordinates)(timeZone, 'exportReading'));
});
var transformToImportCoordinates = (0, _memoizeOne["default"])(function (productionReadings, timeZone) {
  return productionReadings.filter((0, _chartUtils.isValidReading)('importReading')).map((0, _readingsToCoordinates.readingsToCoordinates)(timeZone, 'importReading'));
});
var transformToSolarCoordinates = (0, _memoizeOne["default"])(function (productionReadings, timeZone, fieldName) {
  return productionReadings.filter((0, _chartUtils.isValidReading)(fieldName)).map((0, _readingsToCoordinates.readingsToCoordinates)(timeZone, fieldName));
});
var transformToSelfConsumptionCoordinates = (0, _memoizeOne["default"])(function (productionReadings, timeZone) {
  return productionReadings.filter((0, _chartUtils.isValidReading)('selfConsumption')).map((0, _readingsToCoordinates.readingsToCoordinates)(timeZone, 'selfConsumption'));
});
var transformToBatteryChargeCoordinates = (0, _memoizeOne["default"])(function (batteryReadings, timeZone) {
  return batteryReadings.filter((0, _chartUtils.isValidReading)('batteryCharge')).map((0, _readingsToCoordinates.readingsToCoordinates)(timeZone, 'batteryCharge'));
});
var transformToBatteryDischargeCoordinates = (0, _memoizeOne["default"])(function (batteryReadings, timeZone) {
  return batteryReadings.filter((0, _chartUtils.isValidReading)('batteryDischarge')).map((0, _readingsToCoordinates.readingsToCoordinates)(timeZone, 'batteryDischarge'));
});

var FifteenMinuteChartContainer = function FifteenMinuteChartContainer(_ref) {
  var activeDataValues = _ref.activeDataValues,
      authToken = _ref.authToken,
      baseUrl = _ref.baseUrl,
      hasBattery = _ref.hasBattery,
      hasCT = _ref.hasCT,
      internalUsage = _ref.internalUsage,
      prospectId = _ref.prospectId,
      storageProfile = _ref.storageProfile,
      timeZone = _ref.timeZone,
      viewEndISO = _ref.viewEndISO,
      viewStartISO = _ref.viewStartISO,
      withBatteryChart = _ref.withBatteryChart;

  var _useState = (0, _react.useState)('Battery 1'),
      _useState2 = _slicedToArray(_useState, 2),
      focusedBattery = _useState2[0],
      setFocusedBattery = _useState2[1];

  var _useState3 = (0, _react.useState)(true),
      _useState4 = _slicedToArray(_useState3, 2),
      isToggleActive = _useState4[0],
      setToggle = _useState4[1];

  var setToggleState = function setToggleState() {
    setToggle(!isToggleActive);
  };

  var viewStartDateTime = _luxon.DateTime.fromISO(viewStartISO, {
    zone: timeZone
  });

  var viewEndDateTime = _luxon.DateTime.fromISO(viewEndISO, {
    zone: timeZone
  });

  var startMillis = viewStartDateTime.toMillis();
  var endMillis = viewEndDateTime.toMillis();
  var sitePower = (0, _useSitePower.useSitePower)(prospectId, viewStartISO, viewEndISO, baseUrl, authToken) || [];
  var siteProductionMinute = (0, _useMinutePerformance.useMinutePerformance)(prospectId, viewStartISO, viewEndISO, baseUrl, authToken) || [];
  var minuteBatteryAverage = (0, _useMinuteBattery.useMinuteBatteryAverage)(prospectId, viewStartISO, viewEndISO, baseUrl, authToken, hasBattery) || {};
  var minuteBatteries = (0, _useMinuteBattery.useMinuteBatteries)(prospectId, viewStartISO, viewEndISO, baseUrl, authToken, hasBattery) || [];
  var batteryIsLoading = (0, _useMinuteBattery.useBatteryMinuteLoading)();
  var powerIsLoading = (0, _useSitePower.useSitePowerLoading)();
  var performanceIsLoading = (0, _useMinutePerformance.useMinutePerformanceLoading)();
  var isLoading = batteryIsLoading || powerIsLoading || performanceIsLoading;
  var hasPower = sitePower && sitePower.filter(function (x) {
    return x.batterySolar;
  }).length > 0;
  var useableReadings = hasPower ? sitePower : siteProductionMinute;
  var aggregatedBatteryReadings = hasBattery && minuteBatteryAverage && minuteBatteryAverage.performanceData ? minuteBatteryAverage.performanceData : [];
  var individualBatteryReadings = hasBattery && minuteBatteries && minuteBatteries.length ? organizeBatteryReadings(minuteBatteries) : [];
  var individualBatteryKeys = Object.keys(individualBatteryReadings).filter(function (b) {
    return b !== 'averageBatteryReadings';
  });
  var consumptionCoordinates = activeDataValues.includes('consumption') && hasCT ? transformToConsumptionCoordinates(useableReadings, timeZone) : [];
  var exportAreaCoordinates = activeDataValues.includes('export') && hasCT ? transformToExportCoordinates(useableReadings, timeZone) : [];
  var importCoordinates = activeDataValues.includes('import') && hasCT ? transformToImportCoordinates(useableReadings, timeZone) : [];
  var solarCoordinates = activeDataValues.includes('solar') ? transformToSolarCoordinates(useableReadings, timeZone, hasBattery ? 'batterySolar' : 'pvSolar') : [];
  var selfConsumptionCoordinates = activeDataValues.includes('selfConsumption') && hasCT ? transformToSelfConsumptionCoordinates(useableReadings, timeZone) : [];
  var batteryChargeCoordinates = activeDataValues.includes('charge') ? transformToBatteryChargeCoordinates(hasPower ? useableReadings : aggregatedBatteryReadings, timeZone) : [];
  var batteryDischargeCoordinates = activeDataValues.includes('discharge') ? transformToBatteryDischargeCoordinates(hasPower ? useableReadings : aggregatedBatteryReadings, timeZone) : [];
  var averageBatteryCoordinates = transformToBatteryAveragePercentageCoordinates(aggregatedBatteryReadings, timeZone);
  var individualBatteryCoordinates = individualBatteryKeys.reduce(function (obj, key) {
    // eslint-disable-next-line no-param-reassign
    obj[key] = transformToBatteryAveragePercentageCoordinates(individualBatteryReadings[key], timeZone);
    return obj;
  }, {});
  var coordinatesGroupedByTime = (0, _RecentPerformanceCrosshair.groupCoordinatesByTime)(_objectSpread({
    averageBatteryPercentage: averageBatteryCoordinates,
    charge: batteryChargeCoordinates,
    consumption: consumptionCoordinates,
    discharge: batteryDischargeCoordinates,
    exportValue: exportAreaCoordinates,
    importValue: importCoordinates,
    selfConsumption: selfConsumptionCoordinates,
    solar: solarCoordinates
  }, individualBatteryCoordinates));
  var displayCoordinates = {
    batteryChargeCoordinates: batteryChargeCoordinates,
    batteryDischargeCoordinates: batteryDischargeCoordinates,
    consumptionCoordinates: consumptionCoordinates,
    exportAreaCoordinates: exportAreaCoordinates,
    importCoordinates: importCoordinates,
    selfConsumptionCoordinates: selfConsumptionCoordinates,
    solarCoordinates: solarCoordinates
  };
  return /*#__PURE__*/_react["default"].createElement(_FifteenMinuteChart["default"], {
    averageBatteryCoordinates: averageBatteryCoordinates,
    coordinatesGroupedByTime: coordinatesGroupedByTime,
    displayCoordinates: displayCoordinates,
    endMillis: endMillis,
    focusedBattery: focusedBattery,
    hasBattery: hasBattery,
    individualBatteryCoordinates: individualBatteryCoordinates,
    individualBatteryKeys: individualBatteryKeys,
    internalUsage: internalUsage,
    isLoading: isLoading,
    isToggleActive: isToggleActive,
    key: "".concat(startMillis).concat(endMillis),
    setFocusedBattery: setFocusedBattery,
    setToggleState: setToggleState,
    startMillis: startMillis,
    storageProfile: storageProfile,
    timeZone: timeZone,
    viewEndDateTime: viewEndDateTime,
    viewStartDateTime: viewStartDateTime,
    withBatteryChart: withBatteryChart
  });
};

FifteenMinuteChartContainer.propTypes = {
  activeDataValues: _propTypes["default"].arrayOf(_propTypes["default"].string),
  authToken: _propTypes["default"].string.isRequired,
  baseUrl: _propTypes["default"].string.isRequired,
  hasBattery: _propTypes["default"].bool.isRequired,
  hasCT: _propTypes["default"].bool.isRequired,
  prospectId: _propTypes["default"].string.isRequired,
  storageProfile: _propTypes["default"].shape({
    storageMode: _propTypes["default"].string,
    storageProfileDetails: _propTypes["default"].shape({
      name: _propTypes["default"].string
    })
  }),
  timeZone: _propTypes["default"].string,
  viewEndISO: _propTypes["default"].string.isRequired,
  viewStartISO: _propTypes["default"].string.isRequired,
  withBatteryChart: _propTypes["default"].bool,
  internalUsage: _propTypes["default"].bool
};
FifteenMinuteChartContainer.defaultProps = {
  activeDataValues: ['solar', 'systemProduction', 'consumption', 'selfConsumption', 'peer', 'contract', 'charge', 'discharge', 'export'],
  internalUsage: false,
  storageProfile: {},
  timeZone: 'local',
  withBatteryChart: false
};
var _default = FifteenMinuteChartContainer;
exports["default"] = _default;